import React, { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { Button, Typography, styled } from "@mui/material";
import { RouteImage } from "../../assets/routeImage";
import { ButtonOutlined } from "../mui-custom/MuiCustom";
import { useTranslation } from "react-i18next";
import { notification } from "../../constants/notificationMessage";
import { colors } from "../../constants/colors";
import { saveAs } from "file-saver";

// API
import { FilesApi } from '../../api/files/files.api';

const ContainerDragFile = styled('div')(({ theme }) => ({
    '.custom_style': {
        border: 'none',
        width: '100%',
        maxWidth: "100%",
        height: '100%',
        [theme.breakpoints.down('md')]: {
            minHeight: "170px",
            marginTop: '1rem'
        },
        'svg': {
            display: "none"
        },
        'div': {
            display: "none"
        },
    },
    backgroundImage: ` url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='11' ry='11' stroke='%23C1C3C7' stroke-width='4' stroke-dasharray='2%2c 8' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e")`,
    borderRadius: "10px",
}))
const BoxContainer = styled('div')(({ theme }) => ({
    padding: "17.5px 24px",
    width: "100%",
    height: "100%",
    position: "absolute",
    top: "0",
    left: "0",
    gap: "8px",
    [theme.breakpoints.down('md')]: {
        padding: "1rem 0.5rem",
        flexDirection: "column"
    }
}))

interface props {
    onUpload: (file: any) => void;
    multiple?: boolean;
    fileType?: any;
    disabled?: boolean;
    hoverTitle?: string;
    label?: string;
    required?: boolean;
    name?: string;
    onSizeError?: (errorText: string) => void;
    maxSize?: number;
    minSize?: number;
    onTypeError?: (file: any) => void;
    dropMessageStyle?: {};
    minHeight?: string;
    heading?: string;
    allCenter?: boolean;
    addFileToTable?: (data: any) => void;
    fileId: number;
}

const TrackingDrageAndDrop: React.FC<props> = (props: props) => {

    const { t } = useTranslation();
    const fileTypes: string[] = [`${props.fileType}`, "JPG", "PNG"];

    const [file, setFile] = useState<any>();

    const handleChange = (file: File) => {
        props.onUpload(file);
        setFile(file)
    };
    const handleDeleteFile = () => {
        props.onUpload(null)
        setFile(null)
    }

    const handleTypeError = () => {
        props.onTypeError && props.onTypeError("รูปแบบไฟล์ไม่ถูกต้อง")
    }
    const handleOnSizeError = () => {
        props.onSizeError && props.onSizeError("ขนาดไฟล์ใหญ่เกินไป")
    }


    return (
        <>
            {props.heading && (
                <div className="w-full my-2">
                    <Typography>{props.heading}</Typography>
                </div>
            )}
            <ContainerDragFile

                sx={{
                    '.custom_style': {
                        minHeight: props.allCenter ? props.minHeight : "80px",
                    }
                }}
                style={{ minHeight: props.minHeight }}
                className="relative w-full h-auto">
                <FileUploader
                    classes="drop_area drop_zone custom_style"
                    onTypeError={handleTypeError}
                    onSizeError={handleOnSizeError}
                    required={props.required}
                    label={props.label || "ลากหรือเลือกไฟล์เพื่ออัปโหลด"}
                    hoverTitle={props.hoverTitle || ""}
                    disable={props.disabled}
                    multiple={props.multiple}
                    handleChange={handleChange}
                    name={props.name || "file"}
                    types={props.fileType || fileTypes}
                    maxSize={props.maxSize}
                    minSize={props.minSize}
                    dropMessageStyle={props.dropMessageStyle}

                />
                <BoxContainer
                    className={`${props.fileId === 0 && 'pointer-events-none'} flex absolute items-center ${props.allCenter ? 'justify-center flex-col' : 'justify-between'}`}>
                    <span className={`w-auto flex ${props.allCenter && 'flex-col justify-center items-center text-center gap-y-4'}`}>
                        <div className="flex gap-2 gap-x-4">
                            <span>
                                <img
                                    width={44}
                                    height={31}
                                    src={RouteImage.cloudIconUpload}
                                    alt="upload-file" />
                            </span>
                            <span className="flex flex-col">
                                <Typography variant="h6">{"ลากหรือเลือกไฟล์เพื่ออัปโหลด"}</Typography>
                                <Typography className="text-[rgba(0,0,0,0.40)] text-sm">{"ขนาดไม่เกิน 10MB"}</Typography>
                            </span>
                        </div>
                    </span>
                    <span className="flex flex-col ml-6">
                    </span>
                    <span className="flex w-auto gap-2">
                        <ButtonOutlined
                            sx={{
                                maxWidth: "85px",
                                // border: props.fileId !== 0 ? '1px solid #fff' : `1px solid ${colors.primary_main}`
                                backgroundColor: colors.primary_sub_main
                            }}>
                            <Typography className="text-primary"> {t("UPLOAD_FILE")}</Typography>
                        </ButtonOutlined>
                    </span>
                </BoxContainer>
            </ContainerDragFile>
        </>
    );
}

export default TrackingDrageAndDrop;